/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiscountType } from './discountType';


export interface DiscountDto { 
    id?: number;
    code: string;
    name: string;
    discountPriceType?: DiscountType;
    readonly discountPriceTypeFormatted?: string | null;
    discountAmount?: number;
    discountHours?: number;
    readonly discountAmountFormatted?: string | null;
    activeFrom?: string;
    activeTo?: string;
    isActive?: boolean;
    waiveServiceFee?: boolean;
    waiveTax?: boolean;
}
export namespace DiscountDto {
}


